module.exports = __webpack_public_path__ + "static/media/general-setting.53cb6ccf.svg";